var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 80,
    viewBox: "0 0 130 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0742 15.2281C27.4002 11.0361 28.6342 8.42605 29.7742 7.39705C32.9312 4.54905 37.2962 6.09905 38.2242 6.32105C41.4842 7.10305 40.4242 1.95705 43.2212 0.911054C45.0852 0.214054 46.6182 1.06605 47.8212 3.46705C48.8862 1.22705 50.5092 0.201054 52.6902 0.384054C55.9622 0.661054 57.1072 11.7121 61.6032 9.29305C66.1002 6.87305 71.6132 6.32005 73.9682 9.91605C74.4772 10.6941 74.6722 9.48705 78.1342 5.36605C81.5962 1.24405 85.0482 -0.571946 92.1302 1.82805C95.3502 2.91805 97.9982 5.87305 100.077 10.6921C100.077 17.5701 105.137 21.6421 115.255 22.9051C130.434 24.8001 118.652 41.1191 100.077 45.8981C81.5012 50.6781 38.7342 53.2581 15.5262 41.1821C0.0541611 33.1331 3.57016 24.4811 26.0732 15.2281H26.0742Z",
    fill: "url(#paint0_linear_2017_78066)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.134 76.008C79.5908 76.008 92.121 73.1077 92.121 69.53C92.121 65.9523 79.5908 63.052 64.134 63.052C48.6772 63.052 36.147 65.9523 36.147 69.53C36.147 73.1077 48.6772 76.008 64.134 76.008Z",
    fill: "url(#paint1_linear_2017_78066)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.675,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.384 77.613C90.341 82.891 18.514 76.854 10.869 74.097C7.14801 72.754 3.79401 70.229 0.808008 66.521C0.473808 66.1064 0.263743 65.6057 0.202086 65.0767C0.140429 64.5478 0.229697 64.0122 0.459575 63.5318C0.689453 63.0514 1.05056 62.6459 1.50116 62.3621C1.95177 62.0783 2.47348 61.9278 3.00601 61.928H128.52C131.125 68.866 125.413 74.094 111.384 77.613Z",
    fill: "url(#paint2_linear_2017_78066)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6099 52.1689L76.0389 40.9769C75.8125 40.7099 75.5312 40.4949 75.2142 40.3465C74.8972 40.1981 74.5519 40.1198 74.2019 40.1169H53.6219C52.9159 40.1169 52.2449 40.4409 51.7849 40.9769L42.2139 52.1689V58.3129H85.6099V52.1689Z",
    fill: "url(#paint3_linear_2017_78066)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8978 58.539L74.5208 48.791C74.3183 48.5608 74.0686 48.377 73.7887 48.2519C73.5089 48.1268 73.2053 48.0634 72.8988 48.066H54.9248C54.3078 48.066 53.7048 48.322 53.3028 48.791L44.9258 58.539V63.893H82.8978V58.539Z",
    fill: "url(#paint4_linear_2017_78066)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6099 65.3538C85.6099 66.2068 85.2259 66.9738 84.6199 67.4878L84.4969 67.5878C84.0164 67.952 83.4298 68.1487 82.8269 68.1478H44.9979C44.6559 68.1478 44.3289 68.0858 44.0269 67.9718L43.8769 67.9118C43.382 67.6917 42.9615 67.3328 42.6664 66.8786C42.3713 66.4245 42.2141 65.8945 42.2139 65.3528V52.2358H52.7429C53.9059 52.2358 54.8429 53.1928 54.8429 54.3538V54.3688C54.8429 55.5308 55.7909 56.4678 56.9539 56.4678H70.8699C71.4289 56.4673 71.9649 56.2453 72.3606 55.8504C72.7562 55.4555 72.9793 54.9199 72.9809 54.3608C72.9809 53.1948 73.9189 52.2358 75.0809 52.2358H85.6109L85.6099 65.3538Z",
    fill: "url(#paint5_linear_2017_78066)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2017_78066",
    x1: 66.865,
    y1: 37.3133,
    x2: 66.865,
    y2: -8.3702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9A9",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2017_78066",
    x1: 61.2177,
    y1: 76.008,
    x2: 61.2177,
    y2: 63.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96A1C5",
    stopOpacity: 0.373
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2017_78066",
    x1: 64.6575,
    y1: 79.7064,
    x2: 64.6575,
    y2: 58.4301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919191",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2017_78066",
    x1: 63.9119,
    y1: 40.1169,
    x2: 63.9119,
    y2: 48.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57E6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00818C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2017_78066",
    x1: 68.9791,
    y1: 63.893,
    x2: 68.9791,
    y2: 47.2246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2017_78066",
    x1: 63.9124,
    y1: 52.2358,
    x2: 63.9124,
    y2: 68.1478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AEEF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1F9FC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataImage);
export default __webpack_public_path__ + "static/media/no-data-image.f85e9e740c59ea3182a48f9a17e99aaf.svg";
export { ForwardRef as ReactComponent };